export class FileAPI {
  static get baseUrl() {
    return process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_API_BASE_URL
      : process.env.REACT_APP_API_BASE_URL;
  }
  static postUploadFIle() {
    return {
      method: "POST",
      url: this.baseUrl + "/files/upload",
    };
  }
  static deleteFileByPath(path:string) {
    const params = new URLSearchParams();
    params.append('path', path)
    return {
      method: "DELETE",
      url: this.baseUrl + `/files?${params.toString()}`,
    };
  }
}
